<template>
	<paginated-search v-bind="{ schema, searchEntities, openEntity, createEntity, autoEnable: true }"></paginated-search>
</template>

<script>
	import PaginatedSearch from "@/components/Espresso/BackendPaginatedSearch.vue";
	import User from "@/models/user.model.vue";

	export default {
		components: {
			PaginatedSearch,
		},
		data () {
			return {
				schema: User.getSchema(),
			};
		},
		methods: {
			openEntity(user) {
				this.$router.push(`/usuario/${user.id}`);
			},
			createEntity() {
				this.$router.push(`/usuario/novo`);
			},
			searchEntities(paginationParameters) {
				const searchParameters = Object.assign({
					role: "USER",
					// status: "APPROVED",
				}, paginationParameters);
				return User.search(searchParameters);
			},
		},
	}
</script>
